export enum PreventSpacingAt {
	top = 'top',
	bottom = 'bottom',
	left = 'left',
	right = 'right',
	all = 'all',
	none = 'none'
}
